import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  adminRoleGuard,
  authGuard,
  dashboardPermissionGuard,
  favoritesPermissionGuard,
  integrationsPermissionGuard,
  reportsPermissionGuard,
  rolesPermissionGuard,
  usersPermissionGuard
} from "./core";
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { adminRedirectGuard } from './core/guards/admin-redirect.guard';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'app' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'app',
    component: DashboardLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', canActivate: [adminRedirectGuard], component: DashboardLayoutComponent },
      {
        path: 'dashboard-user',
        loadChildren: () => import('./features/dashboard-user/dashboard-user.module').then(m => m.DashboardUserModule),
        canActivate: [favoritesPermissionGuard]
      },
      {
        path: 'reports-user',
        loadChildren: () => import('./features/reports-user/reports-user.module').then(m => m.ReportsUserModule),
        canActivate: [reportsPermissionGuard]
      },
      {
        path: 'dashboard-company',
        loadChildren: () => import('./features/dashboard-company/dashboard-company.module').then(m => m.DashboardCompanyModule),
        canActivate: [dashboardPermissionGuard]
      },
      // {
      //   path: 'reports-company',
      //   loadChildren: () => import('./features/reports-company/reports-company.module').then(m => m.ReportsCompanyModule)
      // },
      {
        path: 'reports-company',
        loadChildren: () => import('./features/reports-general-view/reports-general-view.module').then(m => m.ReportsGeneralViewModule),
        canActivate: [adminRoleGuard]
      },
      {
        path: 'reports-general-view',
        loadChildren: () => import('./features/reports-general-view/reports-general-view.module').then(m => m.ReportsGeneralViewModule),
        canActivate: [reportsPermissionGuard]
      },
      {
        path: 'logs',
        loadChildren: () => import('./features/logs/logs.module').then(m => m.LogsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule),
        canActivate: [usersPermissionGuard]
      },
      {
        path: 'roles',
        loadChildren: () => import('./features/roles/roles.module').then(m => m.RolesModule),
        canActivate: [rolesPermissionGuard]
      },
      {
        path: 'integrations',
        loadChildren: () => import('./features/integrations/integrations.module').then(m => m.IntegrationsModule),
        canActivate: [integrationsPermissionGuard]
      }
    ]
  },
  { path: '**', redirectTo: 'app' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
